/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionstatusmorning2Inputs */

const en_actionstatusmorning2 = /** @type {(inputs: Actionstatusmorning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will be sent at 8 am`)
};

const de_actionstatusmorning2 = /** @type {(inputs: Actionstatusmorning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird um 8 Uhr verschickt`)
};

/**
* | output |
* | --- |
* | "Will be sent at 8 am" |
*
* @param {Actionstatusmorning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionstatusmorning2 = /** @type {((inputs?: Actionstatusmorning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionstatusmorning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionstatusmorning2(inputs)
	return de_actionstatusmorning2(inputs)
});
export { actionstatusmorning2 as "actionStatusMorning" }